export class RestaurantConfigurationsForm {
  public hasChanged: boolean
  public isSubmitting: boolean

  constructor() {
    this.hasChanged = false
    this.isSubmitting = false
  }
}
